import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
import ServiceWorkerWrapper from "./ServiceWorkerWrapper";

const ele = document.getElementById("root");
const root = createRoot(ele!);
root.render(
  <React.StrictMode>
    <ServiceWorkerWrapper />
    <App />
  </React.StrictMode>
);
